/* eslint-disable no-void */
import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../../../../client-dashboard/src/app/services/api.config';
import useDataFetchIndicator from '../useDataFetchIndicator';

type HookProps = { api: vp.Api };
type HookTuple = [
  response: vp.PartnerAccountTransferAndWithdrawResponse,
  partnerAccountTransfer: (params: vp.PartnerAccountTransferRequest) => Promise<vp.PartnerAccountTransferAndWithdrawResponse>,
  initiatePartnerAccountTransfer: (params: vp.PartnerAccountTransferRequest) => void,
  reset: () => void,
];
type ApiHook = (props: HookProps) => HookTuple;

const usePostPartnerAccountTransferAndWithdraw: ApiHook = ({ api }) => {
  const [, setDataFetchingInfo] = useDataFetchIndicator();
  const [shouldPartnerAccountTransferAndWithdraw, setShouldPartnerAccountTransferAndWithdraw] = useState(false);
  const source = axios.CancelToken.source();
  const [params, setParams] = useState<vp.PartnerAccountTransferRequest>({
    TransferTypeID: '',
    DebitorAccountID: '',
    RecipientAccountID: '',
    Amount: '',
    Currency: '',
    ClientReferenceNumber: '',
    Notes: '',
  });
  const [response, setResponse] = useState<vp.PartnerAccountTransferAndWithdrawResponse>({
    Success: false,
    ErrorMessage: '',
    AccountTransferID: '',
    WithdrawTransactionID: '',
  });

  useEffect(() => {
    if (!shouldPartnerAccountTransferAndWithdraw) return () => {};

    const PostPartnerAccountTransfer = async () => {
      setDataFetchingInfo(true, 'processing', 'fullScreen');
      const res = await api.postPartnerAccountTransferAndWithdraw(params, source);
      setResponse(res);
      setDataFetchingInfo(false);
    };

    if (shouldPartnerAccountTransferAndWithdraw) void PostPartnerAccountTransfer();
    setShouldPartnerAccountTransferAndWithdraw(false);
    return () => {
      source.cancel();
    };
  }, [shouldPartnerAccountTransferAndWithdraw]);

  return [
    response,
    (_params: vp.PartnerAccountTransferRequest) => api.postPartnerAccountTransferAndWithdraw(_params, source),
    (_params: vp.PartnerAccountTransferRequest) => {
      setParams(_params);
      setShouldPartnerAccountTransferAndWithdraw(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        AccountTransferID: '',
        WithdrawTransactionID: '',
      });
      setShouldPartnerAccountTransferAndWithdraw(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(usePostPartnerAccountTransferAndWithdraw);
